import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsWithCountComponent } from './tabs-with-count.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AdjustColorModule } from '../../../directives/adjust-color/adjust-color.module';

@NgModule({
    imports: [
        CommonModule,
        MatTabsModule,
        AdjustColorModule,
    ],
    declarations: [
        TabsWithCountComponent,
    ],
    exports: [
        TabsWithCountComponent,
    ],
})
export class TabsWithCountModule
{
}
